
import { Button } from "@/components/ui/button";
import { useToast } from "@/components/ui/use-toast";
import { captureException } from "@/utils/sentry";

interface SentryTestProps {
  currentUserAddress?: string;
}

const SentryTest = ({ currentUserAddress }: SentryTestProps) => {
  const { toast } = useToast();

  const handleTestSentryError = () => {
    try {
      // Create an error that will be caught by Sentry
      const error = new Error("This is a test error from the Profile page");
      captureException(error, { 
        component: "Profile",
        location: "Break the world button",
        userId: currentUserAddress || 'unknown'
      });
      
      // Show a success toast to indicate the error was captured
      toast({
        title: "Error captured",
        description: "An error was successfully sent to Sentry",
      });
    } catch (e) {
      console.error("Failed to capture error", e);
      // Even capture errors in our error handler
      captureException(e, {
        component: "Profile",
        operation: "testSentryError",
        meta: "Error in error capture function"
      });
    }
  };

  return (
    <Button 
      variant="destructive" 
      onClick={handleTestSentryError}
    >
      Break the world
    </Button>
  );
};

export default SentryTest;
